import type {ComponentType, ReactNode} from 'react';
import {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useConnectivity} from 'src/offline/useConnectivity';

export interface OfflineRouteGuardProps {
  supportsOffline?: boolean;
  OfflineUnavailablePage: ComponentType;
  children: ReactNode;
}

// Blocks routes not backed by an offline session while offline, showing the
// guidance page (injected to keep the app tier off the pages tier).
export const OfflineRouteGuard = ({
  supportsOffline,
  OfflineUnavailablePage,
  children,
}: OfflineRouteGuardProps) => {
  const {key} = useLocation();
  const {isOffline} = useConnectivity();
  // Blocking is decided per navigation so a connectivity blip cannot unmount an
  // open page; the decision lapses the moment the connection returns.
  const [decision, setDecision] = useState({
    key,
    blocked: !supportsOffline && isOffline,
  });
  if (decision.key !== key) {
    setDecision({key, blocked: !supportsOffline && isOffline});
  }

  if (decision.key === key && decision.blocked && isOffline) {
    return <OfflineUnavailablePage />;
  }

  return <>{children}</>;
};
